module.exports = __webpack_public_path__ + "static/img/花瓶4.c19051b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/reliefVase/imgs/花瓶4.png
// module id = lX0f
// module chunks = 2